import React from 'react'
import { Avatar, Box, HStack, Spacer, Text, useDisclosure } from '@chakra-ui/react'
import SideBarDrawer from '../Components/SideBarDrawer'
import { CgMenuLeft } from "react-icons/cg"
import { Link, useLocation } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import { useEffect } from 'react'
import { useState } from 'react'
import jwtDecode from 'jwt-decode'




export default function NavBar() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const location = useLocation();

  let path = location.pathname.replace("/", "").replaceAll("-", " ")
  // s
  const {instance} = useMsal();

  const [UserName, setUserName] = useState("");

  let ImsToken = JSON.parse(localStorage.getItem("ImsToken"))

  // console.log("ims token", jwtDecode(ImsToken))


  const Logout = () => {
    localStorage.clear("accessToken")
    localStorage.clear("ImsToken")
    instance.logoutRedirect({
        scopes: ['user.read']
    })

}

console.log("userInstance", jwtDecode(ImsToken))


  
if (jwtDecode(ImsToken).exp * 1000 <= Date.now()) {
    alert("Session has expired")
    Logout()
} 


  useEffect(() => {
    const currentAccount = instance.getActiveAccount();
    // console.log("currentAcc", currentAccount);

    if(currentAccount){
      setUserName(currentAccount.name);
    }

    
  }, []);
  return (
    <Box width={['100%', '100%', '100%', '100%', '98.5%']} >
      <Box px={["3%", "3%"]} h="auto" padding={"15px"} bg="gray.gray200" borderRadius={"8px"}>  
      <HStack cursor={"pointer"}>
        <HStack>
        <Box onClick={()=>onOpen()} display={["flex","flex","flex","flex","none"]} color={"blue.blue100"} fontSize="40px"><CgMenuLeft/></Box>
        <Link to="/dashboard">
        <Text fontFamily={"body"} fontSize="32px" fontWeight={"700"} color="blue.blue100" letterSpacing={"1.2px"}>IMS</Text>
        </Link>
        </HStack>
        <Spacer />
      
        <HStack fontFamily={"body"} fontSize="18px" fontWeight={"500"} color="blue.blue100">
          <Text display={["none","flex","flex","flex","flex",]} >{UserName} - {path}</Text>

          <Avatar name={`${UserName}`} src='https://bit.ly/broken-link' />

        </HStack>

      </HStack>

      </Box>
      <SideBarDrawer onClose={onClose} isOpen={isOpen} onOpen={onOpen}/>

      
      
    </Box>
  )
}
